import React from 'react';
import '../styles/components/LiquidToggle.css';

/**
 * Composant Toggle avec effet "liquid glass" complexe
 * Structure inspirée de l'exemple avec knockout backdrop + goo filter
 * Uniquement pour Chrome desktop
 */
const LiquidToggle = ({ 
  checked, 
  onChange, 
  label, 
  ariaLabel,
  isActive = false,
  onMouseDown,
  onMouseUp,
  onTouchStart,
  onTouchEnd
}) => {
  const complete = checked ? 100 : 0;

  return (
    <div 
      className="liquid-toggle-wrapper"
      role="switch"
      aria-checked={checked}
      tabIndex={0}
      data-active={isActive}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
    >
      <span className="liquid-toggle-label">{label}</span>
      
      <button
        type="button"
        className="liquid-toggle"
        aria-pressed={checked}
        aria-label={ariaLabel}
        onClick={onChange}
        style={{
          '--complete': complete
        }}
      >
        {/* Knockout backdrop avec masque */}
        <div className="liquid-knockout">
          <div className="liquid-indicator liquid-indicator--masked">
            <div className="liquid-mask"></div>
          </div>
        </div>

        {/* Indicateur de fond */}
        <div className="liquid-indicator liquid-indicator--background"></div>

        {/* Partie liquide avec effet goo */}
        <div className="liquid-indicator__liquid">
          {/* Ombre interne */}
          <div className="liquid-shadow"></div>
          
          {/* Wrapper avec clip-path et blur */}
          <div className="liquid-wrapper">
            <div className="liquid-liquids">
              <div className="liquid__shadow"></div>
              <div className="liquid__track"></div>
            </div>
          </div>
          
          {/* Cover blanc qui cache/révèle */}
          <div className="liquid-cover"></div>
        </div>
      </button>
    </div>
  );
};

export default LiquidToggle;
